module["exports"] = [
  "S.A.",
  "LTDA",
  "e Associados",
  "Comércio"
];
